import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import CustomerService from "services/CustomerService";
export const initialState = {
  data: [],
  dataDetail: [],
  loading: false,
  addressLoading: false,
  error: null,
  redirect: false,
};

export const fetchCustomerData = createAsyncThunk(
  "customer/fetchCustomerData",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, searchText } = data;
      const response = await CustomerService.get({
        page,
        pageSize,
        sort,
        searchText,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchCustomerDetail = createAsyncThunk(
  "customer/fetchCustomerDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await CustomerService.getById(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const createCustomerData = createAsyncThunk(
  "customer/createCustomerData",
  async (data, { rejectWithValue }) => {
    try {
      const { name, phone, email, addr } = data;
      const response = await CustomerService.createCustomer({
        name,
        phone,
        email,
        addr,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const updateCustomerData = createAsyncThunk(
  "customer/updateCustomerData",
  async (data, { rejectWithValue }) => {
    try {
      const { id, name, phone, email } = data;
      const response = await CustomerService.updateCustomer({
        id,
        name,
        phone,
        email,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const deleteCustomerData = createAsyncThunk(
  "customer/deleteCustomerData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await CustomerService.deleteCustomer(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const createCustomerAddress = createAsyncThunk(
  "customer/createCustomerAddress",
  async ({ customerId, addr }, { rejectWithValue }) => {
    try {
      const response = await CustomerService.createAddress(customerId, { addr });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const updateCustomerAddress = createAsyncThunk(
  "customer/updateCustomerAddress",
  async ({ customerId, addressId, addr }, { rejectWithValue }) => {
    try {
      const response = await CustomerService.updateAddress(customerId, addressId, {
        addr,
      });
      return { ...response, addressId };
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const deleteCustomerAddress = createAsyncThunk(
  "customer/deleteCustomerAddress",
  async ({ customerId, addressId }, { rejectWithValue }) => {
    try {
      await CustomerService.deleteAddress(customerId, addressId);
      return { addressId };
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomerData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchCustomerData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchCustomerDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomerDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDetail = action.payload.data;
        state.error = null;
      })
      .addCase(fetchCustomerDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCustomerData.pending, (state) => {
        state.loading = true;
        state.redirect = false;
      })
      .addCase(createCustomerData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(createCustomerData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCustomerData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCustomerData.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDetail = action.payload.data;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(updateCustomerData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteCustomerData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(deleteCustomerData.fulfilled, (state) => {
        state.loading = false;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(deleteCustomerData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCustomerAddress.pending, (state) => {
        state.addressLoading = true;
      })
      .addCase(createCustomerAddress.fulfilled, (state, action) => {
        state.addressLoading = false;
        const created = action.payload?.data;
        if (created && state.dataDetail) {
          const addrs = state.dataDetail.addrs || [];
          state.dataDetail = {
            ...state.dataDetail,
            addrs: [...addrs, created],
          };
        }
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(createCustomerAddress.rejected, (state, action) => {
        state.addressLoading = false;
        state.error = action.payload;
      })
      .addCase(updateCustomerAddress.pending, (state) => {
        state.addressLoading = true;
      })
      .addCase(updateCustomerAddress.fulfilled, (state, action) => {
        state.addressLoading = false;
        const updated = action.payload?.data;
        if (updated && state.dataDetail?.addrs) {
          state.dataDetail = {
            ...state.dataDetail,
            addrs: state.dataDetail.addrs.map((item) =>
              item.id === updated.id ? updated : item
            ),
          };
        }
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(updateCustomerAddress.rejected, (state, action) => {
        state.addressLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteCustomerAddress.pending, (state) => {
        state.addressLoading = true;
      })
      .addCase(deleteCustomerAddress.fulfilled, (state, action) => {
        state.addressLoading = false;
        const addressId = action.payload?.addressId;
        if (addressId != null && state.dataDetail?.addrs) {
          state.dataDetail = {
            ...state.dataDetail,
            addrs: state.dataDetail.addrs.filter((item) => item.id !== addressId),
          };
        }
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(deleteCustomerAddress.rejected, (state, action) => {
        state.addressLoading = false;
        state.error = action.payload;
      });
  },
});

export const { showLoading } = customerSlice.actions;

export default customerSlice.reducer;
